export const allSessionsSelectedMessage = 'All session scores are currently being displayed.';

export const YAxisLabel = 'Answers';
